import React,{useState, useEffect} from 'react';
//import Grid from '@material-ui/core/Grid';
//import LockIcon from '@material-ui/icons/Lock';
//import FavoriteIcon from '@material-ui/icons/Favorite';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Avatar from '@material-ui/core/Avatar';
import FavoriteIcon from '@material-ui/icons/Favorite';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import {Tools} from './Tools';
import {Styles} from './Styles';
import {Girl} from './Inc';
import Create from './Create';
import Ajax from './Ajax';

interface Props {
    userId:string,
    save(id:string):void,
    move(str:string):void,
}
const Top = (props:Props)=> {
    Ajax.setUserId(props.userId);
    const classes = Styles.base();
    const defGirls:Girl[] = [];
    const [states,setStates] = useState({
        modalPage:"",
        isModal:false,
        girls:defGirls,
    })

    const handleModalClose = ()=>{
        setStates({...states,"isModal":false});
    };

    const openCreate = ()=>{
        setStates({...states,"modalPage":"create","isModal":true});
    }
    const close = ()=>{
        setStates({...states,"modalPage":"","isModal":false});
    }
    const start = (uid:string)=>{
        if( props.userId==="" ){
            props.save(uid);
        }
        props.move("board");
    }
    const config = ()=>{
        Ajax.send("config",{},(res:any)=>{
            console.log("config",res);
        });
    }
    
    useEffect( ()=>{
        Ajax.send("girl/latest",{},(res:any)=>{
            if( res.ok ){
                setStates({...states,"girls":res.girls});
            }
        });
    },[]);

    return (
		<div id="top" className={classes.mainRoot}>
            <div style={{padding:"0"}}>
                <List
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            Latest girls
                        </ListSubheader>
                    }
                >
                {states.girls.map((girl:Girl,index:number)=>{
                    const key = "girl"+index;
                    return (
                        <ListItem key={key}>
                            <ListItemAvatar>
                                <Avatar>
                                    <FavoriteIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={girl.name} secondary={girl.hobby}/>
                            <ListItemSecondaryAction>
                                No.{girl.id}
                            </ListItemSecondaryAction>
                        </ListItem>
                    )
                })}
                </List>
            </div>
            <div className={classes.bottomBar}>
                <Button variant="contained" color="primary" style={{width:"100%"}} onClick={openCreate}>START</Button>
            </div>
            <Modal
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
				open={states.isModal}
				onClose={handleModalClose}
			>
				<div style={Tools.getModalStyle()} className={classes.modal}>
                    {states.modalPage==="create" &&
                    <Create userId={props.userId} start={start} close={close}/>
                    }
	    		</div>
			</Modal>
            <Button variant="outlined" onClick={config} style={{display:"none",position:"absolute",bottom:"5em",right:"0"}}>CONFIG</Button>

		</div>
	);
}

export default Top;
